import { IconButton, TableRow, TextField, Tooltip, styled } from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import InfoIcon from '@mui/icons-material/Info';
import { formatNumber } from "utilities/utilities";




//---------------------------------------------------------------------------------------Jsx

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


export const renderCellFile = ( params, onClick ) => {
    return (
        <Tooltip title={`ดูรายละเอียด`}>
            <IconButton id={`btnFile_${params.row.sID}`} size="small" onClick={()=>{onClick(params)}}>
                <InsertDriveFileIcon style={{ color: "#6e130d" }} />
            </IconButton>
        </Tooltip>
    )
}

export const renderCellFileCustomTable = ( id, row, onClick ) => {
    return (
        <Tooltip title={`ดูรายละเอียด`}>
            <IconButton id={`btnFile_${id}`} size="small" onClick={()=>{onClick(row)}}>
                <InsertDriveFileIcon style={{ color: "#6e130d" }} />
            </IconButton>
        </Tooltip>
    )
}

export const renderCellUpdate = (params, handleClick) => {
    return (
        <>
            <span>{params.row.sUpdate}</span>
            <IconButton id={params.row.sID} size="small" onClick={(event) => handleClick(event, params)} >
                <InfoIcon style={{ color: "#6e130d" }} />
            </IconButton>
        </>
    )
}

export const TextFieldInputNumber = ({ value, digit = 2 }) => {
    return (
        <TextField
            id={"total"}
            name={"total"}
            // value={value != null ? numberFormatterLocale(value, digit) : ""}
            value={value != null ? formatNumber(value, digit) : ""}
            variant={"outlined"}
            type={"text"}
            size={"small"}
            fullWidth={true}
            disabled
            inputProps={{
                style: {
                    textAlign: "right",
                }
            }}
        />
    )
}

//---------------------------------------------------------------------------------------function
const onCheckRequireInRow =(rowData)=>{
    return !!(rowData.sStartBook || rowData.sEndBook || rowData.sStartTicketNo || rowData.nTicketPerBook || rowData.sCost)
}

const onCheckRequireInRowWithdraw =(rowData)=>{
    return !!(rowData.nStartBook || rowData.nEndBook )
}

const onCheckRequireInRowSold =(rowData)=>{
    return !!(rowData.nStartBook || rowData.nEndBook || rowData.nEndTicketID || rowData.nTotalTicket )

}

const onCheckRequireInRowReturn =(rowData)=>{
    return !!(rowData.nStartBook || rowData.nEndBook || rowData.nStartTicketID || rowData.nEndTicketID )

}

const parseFloatCheckValue = (value) => {
    if (value === "" || value === null || value === undefined) {
        return null;
    }

    const floatValue = parseFloat(value);
    //not minus value
    if (isNaN(floatValue) || floatValue < 0) {
        return null; 
    }

    return floatValue;
}


const parseFloatNotZero = (value) => {
    if (value === 0 || value === "" || value === null || value === undefined) {
        return null;
    }

    const floatValue = parseFloat(value);
    //not minus value
    if (isNaN(floatValue) || floatValue < 0) {
        return null; 
    }

    return floatValue;
}
const numberFormatterLocale=(value,digit) =>{

    let valueDecimal = null;
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: digit
    });
    if(value !== "" && value != null && !isNaN(value))
    {
        valueDecimal  = numberFormatter.format(value);
    }
    return valueDecimal;
} 


export { onCheckRequireInRow, onCheckRequireInRowWithdraw,parseFloatNotZero,onCheckRequireInRowReturn,onCheckRequireInRowSold, parseFloatCheckValue,numberFormatterLocale }